import type { OrderListParams, OrderListResp, OrderDetailResp } from "@zrt-ai-office/types"
import { apiFetch } from "./client"

/**
 * 获取订单列表
 */
export async function getOrderList(params: OrderListParams): Promise<OrderListResp> {
  return apiFetch<OrderListResp>("/discourse/api/v1/order/list", {
    params: {
      page: params.page,
      pageSize: params.pageSize,
      status: params.status,
    },
  })
}

/**
 * 获取订单详情
 */
export async function getOrderDetail(orderNo: string): Promise<OrderDetailResp> {
  return apiFetch<OrderDetailResp>(`/discourse/api/v1/order/${orderNo}`)
}
